export default "__VITE_ASSET__T6ozSyKC__"